/* eslint-disable @typescript-eslint/no-explicit-any */
import L from "leaflet";
import $ from "jquery";

interface CurrentLocationOptions extends L.ControlOptions {
  title?: string;
}

const CurrentLocationClass = (L.Control as any).extend({
  options: {
    position: "topright",
    title: "Current Location",
  } as CurrentLocationOptions,

  onAdd: function (map: L.Map): HTMLElement {
    const a = $(
      '<div class="leaflet-control-custom-location leaflet-bar" title="' +
        this.options.title +
        '"><a class="" javascript:void(0)></a></div>'
    );
    a.on("click", function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          map.setView(
            [position.coords.latitude, position.coords.longitude],
            map.getMaxZoom() - 3
          );
        });
      }
    });
    a.on("dblclick", function (e) {
      e.originalEvent?.stopPropagation();
    });

    return a[0];
  },

  onRemove: function () {
    // Cleanup if needed
  },
});

export const CurrentLocation = function (
  opts?: CurrentLocationOptions
): any {
  return new CurrentLocationClass(opts);
};
